import { combineReducers } from 'redux';

import union from 'lodash/union';

import * as types from '../../../types/static-catalogs/vehicle-models';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED FETCH, ADD AND EDIT
    case types.VEHICLE_MODELS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      order.forEach((vehicleModelId) => {
        newState[vehicleModelId] = {
          isSelected: false,
          ...entities[vehicleModelId],
          isConfirmed: true
        };
      });
      return newState;
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED FETCH, ADD AND REMOVE
    case types.VEHICLE_MODELS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

// STATES TO KNOW IF IT IS FETCHING, ADDING  OR EDITING
const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.VEHICLE_MODELS_FETCH_STARTED: {
      return true;
    }
    case types.VEHICLE_MODELS_FETCH_COMPLETED:
    case types.VEHICLE_MODELS_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const errorFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.VEHICLE_MODELS_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.VEHICLE_MODELS_FETCH_STARTED:
    case types.VEHICLE_MODELS_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const vehicleModels = combineReducers({
  byId,
  order,
  isFetchingList,
  errorFetchingList
});

export default vehicleModels;

//Own state
export const getOwnState = (state) => state.staticCatalogs.vehicleModels;

//Information
export const getVehicleModel = (state, vehicleModelId) => getOwnState(state).byId[vehicleModelId];
export const getVehicleModelsList = (state) =>
  getOwnState(state).order.map((id) => getVehicleModel(state, id));
export const getVehicleModelsListByMaker = (state, makerId) =>
  getVehicleModelsList(state).filter((model) => model.makerId === makerId);

export const getSelectedVehicleModels = (state) => {
  const selectedVehicleModels = getVehicleModelsList(state).filter(
    (vehicleModel) => vehicleModel.isSelected
  );
  //Si no se selecciona ninguno devuelve null
  if (selectedVehicleModels.length === 0) return null;
  //Si se selecciona más de cero se devuelve el arreglo de los seleccionados
  if (selectedVehicleModels.length > 0) return selectedVehicleModels;
};

export const getSelectedVehicleModel = (state) => {
  const selectedVehicleModels = getVehicleModelsList(state).filter(
    (vehicleModel) => vehicleModel.isSelected
  );
  //Si se selecciona solo uno devuelve solo el seleccionado
  if (selectedVehicleModels.length === 1) return selectedVehicleModels[0];
  //De lo contrario se devuelve null
  else return null;
};

//Status of sagas
export const isFetchingVehicleModel = (state) => getOwnState(state).isFetching;
export const isFetchingListVehicleModels = (state) => getOwnState(state).isFetchingList;

//Errors
export const getFetchingVehicleModelErrors = (state) => getOwnState(state).errorFetching;
export const getFetchingListVehicleModelsErrors = (state) => getOwnState(state).errorFetchingList;
